import React from 'react';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath } from '@nutastic/nutastic-react-app';

const AppLoading = () => {
    const componentClass = 'loading-page';
    return <div className={componentClass}>
        <div className={`${componentClass}__content`}>
            <span>Cori</span>
            <ReactSVG src={getPublicImagePath('loading-heart.svg')} className={`${componentClass}__heart`}/>
            <span>Rocko</span>
        </div>
    </div>;
};

export default AppLoading;
